module.exports = __webpack_public_path__ + "static/media/wx.60ee8b4b.svg";